"use client";

import dynamic from "next/dynamic";

// Дашборд видит только вошедший с флагом dashboard; аноним грузил и исполнял
// его модуль (виджеты, запросы, анимации) на каждом заходе на главную (KAN-1243).
export const HomeDashboardShell = dynamic(
  () => import("./home-dashboard-shell").then((m) => m.HomeDashboardShell),
  { ssr: false },
);
